<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-pu-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-pu-badge">Property Name + USP + Photo</span>

  <div
    class="cr-pu-dropzone"
    [appInlineMedia]="currentDeviceImage"
    [inlineMediaBlockId]="block.blockId"
    (inlineMediaChange)="onChange($event, currentDeviceImageKey)"
  >
    <a *ngIf="currentDeviceImage; else emptyPreview" [href]="previewHref" target="_blank" rel="noopener">
      <img [src]="currentDeviceImage" [alt]="block.variables?.['PropertyUsp1xImageAlt'] || ''" />
    </a>

    <ng-template #emptyPreview>
      <div class="cr-inline-media-icon">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-inline-media-title">Upload image</div>
      <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
    </ng-template>
  </div>

  <span
    class="cr-pu-name"
    [appInlineEdit]="block.variables?.PropertyUsp1xName ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert property name"
    (inlineEditChange)="onChange($event, 'PropertyUsp1xName')"
  ></span>

  <ul class="cr-pu-usp-list">
    <li class="cr-pu-usp-row">
      <img class="cr-pu-checkmark" [src]="checkmarkIconUrl" alt="" />
      <span
        class="cr-pu-usp-text"
        [appInlineEdit]="block.variables?.PropertyUsp1x1Usp ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert USP text 1"
        (inlineEditChange)="onChange($event, 'PropertyUsp1x1Usp')"
      ></span>
    </li>
    <li class="cr-pu-usp-row">
      <img class="cr-pu-checkmark" [src]="checkmarkIconUrl" alt="" />
      <span
        class="cr-pu-usp-text"
        [appInlineEdit]="block.variables?.PropertyUsp1x2Usp ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert USP text 2"
        (inlineEditChange)="onChange($event, 'PropertyUsp1x2Usp')"
      ></span>
    </li>
    <li class="cr-pu-usp-row">
      <img class="cr-pu-checkmark" [src]="checkmarkIconUrl" alt="" />
      <span
        class="cr-pu-usp-text"
        [appInlineEdit]="block.variables?.PropertyUsp1x3Usp ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert USP text 3"
        (inlineEditChange)="onChange($event, 'PropertyUsp1x3Usp')"
      ></span>
    </li>
  </ul>

  <!-- No edit control for these (matches v1) - shown read-only when already set. -->
  <a
    class="cr-pu-cta"
    *ngIf="block.variables?.PropertyUsp1xCtaLink"
    [href]="helper.getFullUrl(block.variables?.['PropertyUsp1xCtaLink'])"
    target="_blank"
    rel="noopener"
  >
    {{ block.variables?.PropertyUsp1xCtaText }}
  </a>
</div>

<!-- Right panel: real edit form -->
<div class="cr-pu-edit" *ngIf="!isPreview">
  <div class="cr-pu-field-row">
    <span class="cr-pu-field-label">Desktop Image</span>
    <span
      class="cr-pu-toggle"
      [class.cr-pu-toggle-on]="desktopImageAsUpload"
      role="button"
      tabindex="0"
      [title]="desktopImageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleDesktopImageMode()"
      (keydown.enter)="toggleDesktopImageMode()"
      (keydown.space)="toggleDesktopImageMode()"
    ></span>
  </div>
  <div class="cr-pu-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['PropertyUsp1xImgDesktop'] ?? ''"
      (handleOnChange)="onChange($event, 'PropertyUsp1xImgDesktop')"
      [placeholder]="imageDesktopPlaceholder"
      variable="PropertyUsp1xImgDesktop"
      [isImage]="desktopImageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-pu-empty-overlay" *ngIf="desktopImageAsUpload && !block.variables?.['PropertyUsp1xImgDesktop']">
      <div class="cr-pu-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-pu-title">Upload image</div>
      <div class="cr-pu-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-pu-field-row">
    <span class="cr-pu-field-label">Mobile Image</span>
    <span
      class="cr-pu-toggle"
      [class.cr-pu-toggle-on]="mobileImageAsUpload"
      role="button"
      tabindex="0"
      [title]="mobileImageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleMobileImageMode()"
      (keydown.enter)="toggleMobileImageMode()"
      (keydown.space)="toggleMobileImageMode()"
    ></span>
  </div>
  <div class="cr-pu-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['PropertyUsp1xImageMobile'] ?? ''"
      (handleOnChange)="onChange($event, 'PropertyUsp1xImageMobile')"
      [placeholder]="imageMobilePlaceholder"
      variable="PropertyUsp1xImageMobile"
      [isImage]="mobileImageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-pu-empty-overlay" *ngIf="mobileImageAsUpload && !block.variables?.['PropertyUsp1xImageMobile']">
      <div class="cr-pu-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-pu-title">Upload image</div>
      <div class="cr-pu-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-pu-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['PropertyUsp1xImageHref'] ?? ''"
      (handleOnChange)="onChange($event, 'PropertyUsp1xImageHref')"
      [placeholder]="imageHrefPlaceholder"
      variable="PropertyUsp1xImageHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'PropertyUsp1xImageHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['PropertyUsp1xImageHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="alt"
    [blockData]="block.variables?.['PropertyUsp1xImageAlt'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyUsp1xImageAlt')"
    [placeholder]="imageAltPlaceholder"
    [maxLength]="500"
    variable="PropertyUsp1xImageAlt"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['PropertyUsp1xName'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyUsp1xName')"
    [placeholder]="namePlaceholder"
    [maxLength]="500"
    variable="PropertyUsp1xName"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['PropertyUsp1x1Usp'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyUsp1x1Usp')"
    [placeholder]="usp1Placeholder"
    [maxLength]="4000"
    variable="PropertyUsp1x1Usp"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['PropertyUsp1x2Usp'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyUsp1x2Usp')"
    [placeholder]="usp2Placeholder"
    [maxLength]="4000"
    variable="PropertyUsp1x2Usp"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['PropertyUsp1x3Usp'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyUsp1x3Usp')"
    [placeholder]="usp3Placeholder"
    [maxLength]="4000"
    variable="PropertyUsp1x3Usp"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
